import React from 'react';
import { Box } from '@chakra-ui/react';
import { Hero } from '../features/hero';
import { Services } from '../features/services';
import { Solutions } from '../features/solutions';
import { Features } from '../features/features';
import { Process } from '../features/process';
import { About } from '../features/about';

import { FAQ } from '../features/faq';
import { CTA } from '../features/cta';
import { Contact } from '../features/contact';
import { ScrollToTop } from '../features/navigation';

const HomePage: React.FC = () => {
  return (
    <Box as="main" flex="1">
      <Hero />
      <Services id="services" />
      <Features id="features" />
      <Solutions id="solutions" />
      <Process id="process" />
      <About id="about" />

      <FAQ id="faq" />
      <CTA id="cta" />
      <Contact id="contact" />
      <ScrollToTop />
    </Box>
  );
};

export default HomePage;